export const AbsoluteSecureDeviceUrl = {
  mounted() {
    this.expandPath();
  },

  updated() {
    this.expandPath();
  },

  expandPath() {
    const path = this.el.dataset.path;

    if (path && path.startsWith('/')) {
      this.el.value = new URL(path, window.location.origin).href;
    }
  }
};

export const AbsoluteMonitorAccessUrl = AbsoluteSecureDeviceUrl;
